import React, { ReactNode, useState, createContext, useEffect } from "react";
import { getItemStorage, setItemStorage } from "../utils/localStorage";
import { SESSION_KEYS } from "../utils/constants";

export type ItemSessionKey = typeof SESSION_KEYS[number];
interface SessionContextType {
  getItemSession: (key: ItemSessionKey) => string | null;
  setItemSession: (key: ItemSessionKey, value: string) => void;
  clearStorage: () => void;
  removeItemSession: (key: ItemSessionKey) => void;
}

const initialSessionContext: SessionContextType = {
  getItemSession: () => null,
  setItemSession: () => {},
  clearStorage: () => {},
  removeItemSession: () => {},
};

export const SessionContext = createContext<SessionContextType>(
  initialSessionContext
);

interface SessionProviderProps {
  children: ReactNode;
}

export function SessionStorageStorage({ children }: SessionProviderProps) {
  const [storage, setStorage] = useState<Record<string, string>>({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (Object.keys(storage).length !== 0) return;

    async function populateStorage() {
      for (const key of SESSION_KEYS) {
        const content = await getItemStorage(key);

        if (content) {
          setStorage((prevStorage) => ({ ...prevStorage, [key]: content }));
        }
      }

      setLoading(false);
    }

    populateStorage();
  }, [storage]);

  function setItemSession(key: ItemSessionKey, value: string) {
    setItemStorage(key as string, value);
    setStorage((prevStorage) => ({ ...prevStorage, [key]: value }));
  }

  function clearStorage() {
    setStorage({});;
  }

  function removeItemSession(key: ItemSessionKey) {
    setItemStorage(key, "");
    setStorage((prevStorage) => {
      const newStorage = { ...prevStorage };
      delete newStorage[key];
      return newStorage;
    });
  }

  function getItemSession(key: ItemSessionKey): string | null {
    return storage[key as string] as string | null;
  }

  if (loading) return <></>;

  return (
    <SessionContext.Provider
     
      value={{
        getItemSession,
        setItemSession,
        clearStorage,
        removeItemSession,
      }}
    
    >
      {children}
    </SessionContext.Provider>
  );
}
